import { defineStore } from 'pinia'




export const useDrawerStore = defineStore({
  id: 'drawer',
  state: () => ({
    data:true,
    // Текущая тема приложения. Дефолт всегда тёмный; светлую включаем только
    // если пользователь сам переключил её кнопкой в аппбаре (см. App.vue)
    theme: 'dark',
  }),

  actions: {
    change_drawer() {
      this.$patch({
        data: !this.data
    })

  },
  change_theme(data) {
    this.$patch({
    theme: data
  })

},


  }
})
